import { render } from "./ManageEventStatus.vue?vue&type=template&id=17d98818&scoped=true"
import script from "./ManageEventStatus.vue?vue&type=script&lang=js"
export * from "./ManageEventStatus.vue?vue&type=script&lang=js"

import "./ManageEventStatus.vue?vue&type=style&index=0&id=17d98818&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17d98818"

export default script